export default {
    ca: {
        title: 'NOVES FORMACIONS D\'INSTAMAPS',
        titleAdm: 'Taller d\'Instamaps per a Administracions',
        titleEnsenyament: 'Taller d\'Instamaps per a Mestres',
        messageBcn: 'El dimarts 25 de febrer de 18.15 a 20.15 hores farem una nova jornada pràctica de Instamaps per a tots els nivells. També us explicarem novetats, millores i trucs  de l’eina. ',
        messageTremp: 'TREMP, dijous 28 de febrer a les 11:00. ',
        messageEnsenyament: 'Mestres! ...ja és oberta la inscripció a la jornada virtual "Cartografia, Mapes i Geolocalització aplicades a l’educació", coorganitzada pel Departament d\'Educació i l\'ICGC, on aprendrem diferents aspectes relacionats amb el mapa amb Instamaps com a fil argumental.',
        messageInscripcio: 'Us podeu inscriure a ',
        messageLinkEnsenyament: 'http://xtec.gencat.cat/ca/agenda/Inscripcio-a-la-Jornada-Cartografia-Mapes-i-Geolocalitzacio-aplicades-a-leducacio',
        message: 'Inscriviu-vos ',
        messageLink: 'https://www.icgc.cat/L-ICGC/Agenda/Jornada-d-Instamaps2',
        messageLinkTremp: 'http://www.icgc.cat/L-ICGC/Agenda2/Taller-d-Instamaps-a-Tremp',
        messageLinkText: 'aquí',
        messageAltres: 'Si sou un grup i voleu una formació a mida, escriviu a ',
        messageLink1:'https://www.icgc.cat/L-ICGC/Agenda/Taller-en-linia-d-Instamaps-per-al-turisme-de-muntanya',
        messageLink2:'https://icgc.cat/L-ICGC/Agenda/Sessio-en-linia-d-Instamaps',
        messageLink3:'https://icgc.cat/L-ICGC/Agenda/Sessio-en-linia-d-Instamaps2',
        messageMuntanya1:'Taller en línia d\'Instamaps per al turisme de muntanya',
        messageMuntanya2:'28.04.2021, d\'11 a 13 hores. ',
       messageGeneral1:'Taller en línia d\'Instamaps',
        messageGeneral2:'26.10.2021, de 18.15 a 19.45 hores. ',
        messageGeneral3:'28.10.2021 de 9.30 a 11.00 hores. '
    },
    es: {
        title: 'NUEVAS FORMACIONES DE INSTAMAPS',
        titleAdm: 'Taller de Instamaps para Administraciones',
        titleEnsenyament: 'Taller de Instamaps para Maestros',
        messageBcn: 'El martes 25 de febrero de 18.15 a 20.15 horas haremos una nueva jornada práctica de Instamaps para todos los niveles. También os explicaremos novedades, mejoras y trucos de la herramienta. ',
        messageEnsenyament: 'Maestros! ...ya está abierta és oberta la inscripción a la jornada virtual "Cartografía, Mapas y Geolocalización aplicadas a la educación", coorganizada por el Departament d\'Educcació y el ICGC, donde aprendremos diferentes aspectos relacionados con el mapa con Instamaps como hilo argumental.',
        messageTremp: 'TREMP, jueves 28 de febrero a las 11:00. ',
        messageLinkEnsenyament: 'http://xtec.gencat.cat/ca/agenda/Inscripcio-a-la-Jornada-Cartografia-Mapes-i-Geolocalitzacio-aplicades-a-leducacio',
        message: 'Regístrese ',
        messageLink: 'https://www.icgc.cat/L-ICGC/Agenda/Jornada-d-Instamaps2',
        messageLinkTremp: 'http://www.icgc.cat/L-ICGC/Agenda2/Taller-d-Instamaps-a-Tremp',
        messageLinkText: 'aquí', 
        messageAltres: 'Si sois un grupo y quereis una formación a medida, escribid a ',
        messageLink1:'https://www.icgc.cat/L-ICGC/Agenda/Taller-en-linia-d-Instamaps-per-al-turisme-de-muntanya',
        messageLink2:'https://www.icgc.cat/L-ICGC/Agenda/Sessio-d-Instamaps',
        messageLink3:'https://www.icgc.cat/L-ICGC/Agenda/Sessio-d-Instamaps2',
        messageMuntanya1:'Taller en línia de Instamaps para el turismo de montaña',
        messageMuntanya2:'28.04.2021, de 11 a 13 horas. ',
         messageGeneral1:'Taller en línia de Instamaps',
        messageGeneral2:'26.10.2021, de 18.15 a 19.45 hores. ',
        messageGeneral3:'28.10.2021 de 9.30 a 11.00 hores. '
    },
    en: {
        title: 'NEW INSTAMAPS WORKSHOPS',
        titleAdm: 'Instamaps workshop for Administration',
        titleEnsenyament: 'Instamaps workshop for Teachers',
        messageBcn: 'On Febraury 25th from 6.15 p.m. to 8:15 p.m., we will do a new practical day of Instamaps for all levels. We will also explain the news, improvements and tips about the tool. ',
        messageEnsenyament: 'Teachers! ... registration is now open for the virtual day "Cartography, Maps and Geolocation applied to education", co-organized by the Department of Education and the ICGC, where we will learn different aspects related to the map with Instamaps as a thread argument.',
        messageLinkEnsenyament: 'http://xtec.gencat.cat/ca/agenda/Inscripcio-a-la-Jornada-Cartografia-Mapes-i-Geolocalitzacio-aplicades-a-leducacio',
        messageTremp: 'TREMP, thursday 28th february at 11:00. ',
        message: 'Sign up ',
        messageLink: 'https://www.icgc.cat/L-ICGC/Agenda/Jornada-d-Instamaps2',
        messageLinkTremp: 'http://www.icgc.cat/L-ICGC/Agenda2/Taller-d-Instamaps-a-Tremp',
        messageLinkText: 'here',
        messageAltres: 'If you are a group and want customized training, write to ',
        messageLink1:'https://www.icgc.cat/L-ICGC/Agenda/Taller-en-linia-d-Instamaps-per-al-turisme-de-muntanya',
        messageLink2:'https://www.icgc.cat/L-ICGC/Agenda/Sessio-d-Instamaps3',
        messageLink3:'https://www.icgc.cat/L-ICGC/Agenda/Sessio-d-Instamaps2',
        messageMuntanya1:'Instamaps online workshop for mountain tourism',
        messageMuntanya2:'28.04.2021, from 11 a.m. to 1 p.m. ',
        messageGeneral1:'Instamaps online workshop',
        messageGeneral2:'26.10.2021, from 6.15 pm to 7.45 pm. ',
        messageGeneral3:'28.10.2021 from 09.30 to 11.00 am. '
    },
};



// WEBPACK FOOTER //
// ./src/home/components/inscripcio-modal/inscripcio-modal-translations.js